import { useRef } from "react";
import "../styles/list.css";

export const List = props => {
    const {items, itemRenderer, className, draggable, ...other} = props;
    const listRef = useRef(null);
    const dragRef = useRef(null);

    const onDragStartHelper = (e, item) =>{
        dragRef.current = { item: item, parentElement: e.target.closest(".drag-provider")};
        return dragRef.current;
    };

    const onDragOverHelper = (e) => 
    {
        e.preventDefault();
    }
    
    const onDropHelper = (e, item) => {
        if (!dragRef?.current)
            return;

        const sourceParentElement = dragRef.current.parentElement;
        const parentElement = e.target.closest(".drag-provider");

        if (sourceParentElement == parentElement)
        {
            var element = e.target.closest("[data-drag-id]");
            return {sourceItem: dragRef.current.item, targetItemId: element.getAttribute("data-drag-id")};
        }
    };

    return (
        <div ref={listRef} className={`list-container drag-provider ${className}`}>
            <div className="list-root">
            {
                items.map((item, index) => itemRenderer({onDragStartHelper, onDragOverHelper, onDropHelper, ...props}, item, index))                                            
            }
            </div>
        </div>
    );
};